import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=85fb817a&lang=pug&"
import script from "./radio.vue?vue&type=script&lang=js&"
export * from "./radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./radio.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "~/lang/formFields?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230924131341%2Fcomponents%2Fwidgets%2Fforms%2Fradio.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports